enum OrderFinishedListingExecutionStatus {
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export default OrderFinishedListingExecutionStatus;
